/* eslint-disable no-use-before-define */

export interface MobileGridConfig {
  content: Content;
}

export interface Content {
  news: TreatmentType;
  opinion: TreatmentType;
}

export interface TreatmentType {
  article?: ContentType | null;
  video?: ContentType | null;
  audio?: ContentType | null;
  LC?: ContentType | null;
}

export interface ContentType {
  L?: SizeConfig | null;
  M?: SizeConfig | null;
  S?: SizeConfig | null;
}

export type ContentTypeKeys = keyof ContentType;

export interface SizeConfig {
  STANDARD_NEWS?: TreatmentConfig | null;
  BREAKING_NEWS?: TreatmentConfig | null;
  EXCLUSIVE?: TreatmentConfig | null;
  LIVE?: TreatmentConfig | null;
  STANDARD_OPINION?: TreatmentConfig | null;
  BREAKING_OPINION?: TreatmentConfig | null;
  EXCLUSIVE_OPINION?: TreatmentConfig | null;
}

export type SizeConfigKeys = keyof SizeConfig;

export interface TreatmentConfig {
  options?: Array<TreatmentOption> | null;
  label?: string | null;
  autoProperties?: {
    [key: string]: string | boolean;
  } | null;
}

export interface TreatmentOptionConfig {
  disabled: boolean;
  values: string[] | boolean[];
  defaultValue: string | boolean;
}

export interface TreatmentOption {
  [key: string]: TreatmentOptionConfig | null | undefined;
}

export const CurationContentTreatmentValues = {
  standard: 'STANDARD_NEWS',
  breaking: 'BREAKING_NEWS',
  exclusive: 'EXCLUSIVE_NEWS',
  'a-hed': 'A_HED',
  lifestyle: 'LIFESTYLE',
  live: 'LIVE'
};

export const CurationOpinionTreatmentValues = {
  standard: 'STANDARD_OPINION',
  breaking: 'BREAKING_OPINION',
  exclusive: 'EXCLUSIVE_OPINION'
};
